import styled from 'styled-components';

export const FeedbackItemContainer = styled.div`
  background: white;
  margin-top: 16px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  gap: 12px;
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.03);
  border-radius: 6px;
`;

export const NameContainer = styled.h4`
    margin: 2px
`;
